import { Link } from "@mui/material";
import { ChevronRight } from "@mui/icons-material";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

/**
 * ViewAllLink Component
 * Reusable link component for "View All" / "Manage" navigation links
 * Used consistently across table cards in the home page
 */
export default function ViewAllLink({ label, to, onClick }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (to) {
      navigate(to);
    }
  };

  return (
    <Link
      component="button"
      variant="body2"
      onClick={handleClick}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        textDecoration: "none",
        color: "text.primary",
        "&:hover": {
          textDecoration: "underline",
        },
      }}
    >
      {label}
      <ChevronRight fontSize="small" />
    </Link>
  );
}

ViewAllLink.propTypes = {
  label: PropTypes.string.isRequired,
  to: PropTypes.string,
  onClick: PropTypes.func,
};
